import { render, staticRenderFns } from "./PurchaseListDrawer.vue?vue&type=template&id=952a39fe&scoped=true"
import script from "./PurchaseListDrawer.vue?vue&type=script&lang=ts"
export * from "./PurchaseListDrawer.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseListDrawer.vue?vue&type=style&index=0&id=952a39fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a39fe",
  null
  
)

export default component.exports